module.exports = "/images/de.svg?be04df68b663943edb64ce0950c1fde1";